import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon from '@material-ui/core/Icon';
import ProgramHistoryModal from '../../Modals/ProgramHistoryModal';

const Button = styled.button`
  background-color: #2bd855;
  color: white;
  padding: 7px 8px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  border-radius: 5px;
  font-size: 14px;
  font-family: 'Roboto';
  margin-top: 11px;
  box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12);
  font-weight: 550;
  &:hover {
    background-color: rgba(0,0,0,0.12);
  }
`


const ProgramHistoryButton = ({ programHistory, ...other }) => {
  const [modalOpen, setModalOpen] = useState(false);
    
  const handleOpenModal = (e) => {
    e.preventDefault();
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <div>
      <Button onClick={(e) => handleOpenModal(e)}>
        <Icon>history</Icon> PROGRAM HISTORY
      </Button>
      <ProgramHistoryModal open={modalOpen} handleClose={handleCloseModal} historyOfPrograms={programHistory} />
    </div>

  );
};

ProgramHistoryButton.propTypes = {
  questionsAnswers: PropTypes.array,
};

export default ProgramHistoryButton;